import React, { useEffect, useState } from 'react'
import { UserIcon, KeyIcon } from '@heroicons/react/outline'
import { useNavigate } from 'react-router-dom'
import { authenticated } from '../recoil/auth'
import { login } from '../services/firebase_service'
import { useRecoilState } from 'recoil'
import WaitingText from '../components/WaitingText'

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [msgError, setMsgError] = useState('');
  const [auth, setAuth] = useRecoilState(authenticated);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsgError('');
    const result = await login(username, password);
    if (result.success) {
      setLoading(false);
      const data = {
        check: true,
        token: result.data,
        isExpired: false,
      };
      setAuth(data);
      window.localStorage.setItem('token', result.data);
      navigate("/", {replace: true});
    } else {
      setLoading(false);
      setMsgError(result.message);
    }
  };

  useEffect(() => {
    document.title = 'Masuk - Admin Hi Nano';
    if (auth.isExpired) {
      setMsgError('Sesi berakhir, silahkan masuk kembali!');
    }
  }, [auth.isExpired]);
  
  return (
    <div className="flex items-center justify-center min-h-screen bg-slate-100">
      <div className="w-1/3 p-10 bg-white rounded-lg shadow">
        
        <h1 className="mb-3 text-3xl font-semibold">Login Admin</h1>
        <p className="mb-5 text-lg text-slate-500">Masukkan username dan password 🔐</p>
        
        <form onSubmit={handleLogin}>
            <div className="flex flex-col items-start mb-5">
                <label htmlFor="username" className="text-sm">Username</label>
                <div className="flex items-center flex-1 w-full gap-5 px-5 py-3 mt-2 rounded-lg bg-slate-50">
                    <UserIcon className="w-6 h-6" />
                    <input type="text" name="username" id="username" onChange={e => setUsername(e.target.value)} className="w-full p-0 bg-transparent border-none focus:ring-0" placeholder="Username Admin" />
                </div>
            </div>
            <div className="flex flex-col items-start mb-5">
                <label htmlFor="password" className="text-sm">Password</label>
                <div className="flex items-center flex-1 w-full gap-5 px-5 py-3 mt-2 rounded-lg bg-slate-50">
                    <KeyIcon className="w-6 h-6" />
                    <input type="password" name="password" id="password" onChange={e => setPassword(e.target.value)} className="w-full p-0 bg-transparent border-none focus:ring-0" placeholder="Password Admin" />
                </div>
            </div>
            <div className="text-sm text-red-500">{msgError}</div>
            {
              loading 
              ? <button type="button" className="w-full p-3 mt-5 text-center text-white bg-blue-600 rounded-lg shadow shadow-blue-100">
                    <span className="flex justify-center">
                      <WaitingText />
                    </span>
                </button> 
              : <button type="submit" className="w-full p-3 mt-5 text-white bg-blue-600 rounded-lg shadow cursor-pointer hover:bg-blue-700 shadow-blue-100">
                    Masuk
                </button>
            }
        </form>
      </div>
    </div>
  )
}

export default LoginPage